import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api";
import { useNavigate } from "react-router-dom";

export default function Movimientos() {
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({
    busqueda: "",
    estado: "",
    desde: "",
    hasta: "",
  });
  const nav = useNavigate();
  const usuario = JSON.parse(localStorage.getItem("usuario") || "null");

  const fetchMovimientos = async () => {
    try {
      const res = await API.get("/operaciones/mis-movimientos/");
      setMovimientos(res.data || []);
    } catch (error) {
      console.error("Error obteniendo movimientos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMovimientos();
  }, []);

  const getEstadoLegible = (op) => {
    if (op.estado === "PAGADO") return "exitoso";
    if (op.estado === "FALLIDA") return "rechazado";
    return "pendiente";
  };

  const getDescripcion = (op) => {
    const contraparte =
      usuario?.role === "comprador"
        ? op.cliente?.email
        : op.comprador?.email;
    return `Operacion sobre "${op.publicacion?.titulo}" con ${contraparte || "contraparte"}`;
  };

  const aplicarFiltros = (op) => {
    const { busqueda, estado, desde, hasta } = filtros;
    const descripcion = getDescripcion(op);
    const estadoLegible = getEstadoLegible(op);

    if (busqueda && !descripcion.toLowerCase().includes(busqueda.toLowerCase())) {
      return false;
    }
    if (estado && estadoLegible !== estado) return false;
    if (desde && new Date(op.fecha_creacion) < new Date(desde)) return false;
    if (hasta && new Date(op.fecha_creacion) > new Date(hasta)) return false;
    return true;
  };

  const movimientosFiltrados = movimientos.filter(aplicarFiltros);

  const getColorEstado = (estado) => {
    switch (estado) {
      case "exitoso":
        return "text-emerald-600";
      case "pendiente":
        return "text-yellow-600";
      case "rechazado":
        return "text-red-600";
      default:
        return "text-slate-600";
    }
  };

  if (loading) return <p>Cargando movimientos...</p>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-primary">Historial de Movimientos</h1>
      <p className="text-slate-600">
        Revisá operaciones cerradas, comprobantes, datos financieros y conversación histórica.
      </p>

      <Card className="space-y-4">
        <h2 className="text-lg font-semibold text-primary">Filtros</h2>

        <input
          type="text"
          placeholder="Buscar por publicación o contraparte..."
          className="border rounded p-2 w-full"
          value={filtros.busqueda}
          onChange={(e) => setFiltros({ ...filtros, busqueda: e.target.value })}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <select
            className="border p-2 rounded"
            value={filtros.estado}
            onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
          >
            <option value="">Estado</option>
            <option value="exitoso">Exitoso</option>
            <option value="pendiente">Pendiente</option>
            <option value="rechazado">Rechazado</option>
          </select>

          <input
            type="date"
            className="border rounded p-2"
            value={filtros.desde}
            onChange={(e) => setFiltros({ ...filtros, desde: e.target.value })}
          />

          <input
            type="date"
            className="border rounded p-2"
            value={filtros.hasta}
            onChange={(e) => setFiltros({ ...filtros, hasta: e.target.value })}
          />
        </div>

        <Button className="bg-primary text-white">Exportar PDF</Button>
      </Card>

      {movimientosFiltrados.length === 0 ? (
        <Card>
          <p className="text-slate-500">No hay movimientos para mostrar.</p>
        </Card>
      ) : (
        <div className="space-y-4">
          {movimientosFiltrados.map((op) => {
            const estadoLegible = getEstadoLegible(op);
            const contraparte =
              usuario?.role === "comprador" ? op.cliente : op.comprador;

            return (
              <Card key={op.id} className="space-y-4">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
                  <div>
                    <h2 className="text-lg font-semibold text-primary">
                      {op.publicacion?.titulo}
                    </h2>
                    <p className="text-sm text-slate-600">
                      {getDescripcion(op)}
                    </p>
                  </div>

                  <div className="text-sm">
                    <p className={`font-semibold ${getColorEstado(estadoLegible)}`}>
                      {estadoLegible.toUpperCase()}
                    </p>
                    <p className="text-slate-500">
                      {new Date(op.fecha_creacion).toLocaleString()}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                  <p><b>Monto publicación:</b> {Number(op.publicacion?.monto || 0).toLocaleString("es-PY")} Gs</p>
                  <p><b>Monto oferta:</b> {Number(op.oferta?.monto || 0).toLocaleString("es-PY")} Gs</p>
                  <p><b>Estado operación:</b> {op.estado}</p>
                  <p><b>Backoffice:</b> {op.estado_backoffice}</p>
                  <p><b>Contraparte:</b> {contraparte?.email || "-"}</p>
                  <p><b>Fecha aprobación backoffice:</b> {op.fecha_aprobacion_backoffice ? new Date(op.fecha_aprobacion_backoffice).toLocaleString() : "-"}</p>
                </div>

                {op.publicacion?.factura_data && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                    <p><b>CDC:</b> {op.publicacion.factura_data.cdc}</p>
                    <p><b>RUC emisor:</b> {op.publicacion.factura_data.ruc_emisor || "-"}</p>
                    <p><b>RUC receptor:</b> {op.publicacion.factura_data.ruc_receptor || "-"}</p>
                    <p><b>Email deudor:</b> {op.publicacion.factura_data.email_deudor || "-"}</p>
                    <p><b>Email finanzas emisor original:</b> {op.publicacion.factura_data.email_finanzas_emisor_original || "-"}</p>
                    <p><b>Email finanzas receptor original:</b> {op.publicacion.factura_data.email_finanzas_receptor_original || "-"}</p>
                    <p><b>Email finanzas receptor actual:</b> {op.email_finanzas_receptor_actual || "-"}</p>
                  </div>
                )}

                {op.comprobante_transferencia_url && (
                  <p className="text-sm">
                    <b>Comprobante:</b>{" "}
                    <a
                      href={op.comprobante_transferencia_url}
                      target="_blank"
                      rel="noreferrer"
                      className="text-blue-600 underline"
                    >
                      Ver comprobante
                    </a>
                  </p>
                )}

                <div className="flex flex-wrap gap-2 text-xs">
                  <span className={`px-3 py-1 rounded-full ${op.comprador_acepto_venta ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>
                    Comprador {op.comprador_acepto_venta ? "confirmó" : "pendiente"}
                  </span>
                  <span className={`px-3 py-1 rounded-full ${op.vendedor_acepto_venta ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-600"}`}>
                    Vendedor {op.vendedor_acepto_venta ? "confirmó" : "pendiente"}
                  </span>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-primary">Historial de chat</h3>
                    {op.chat_resumen?.id && (
                      <Button
                        className="!bg-accent !text-black"
                        onClick={() =>
                          nav("/chat-operacion", { state: { operacionId: op.id } })
                        }
                      >
                        Ver chat completo
                      </Button>
                    )}
                  </div>

                  {!op.chat_resumen?.mensajes?.length ? (
                    <p className="text-sm text-slate-500">No hubo mensajes registrados.</p>
                  ) : (
                    <div className="space-y-2">
                      {op.chat_resumen.mensajes.map((msg) => (
                        <div key={msg.id} className="border rounded p-3 bg-slate-50">
                          <div className="flex items-center justify-between gap-3 text-xs text-slate-500">
                            <span>{msg.remitente_nombre || "Usuario"}</span>
                            <span>{new Date(msg.fecha).toLocaleString()}</span>
                          </div>
                          <p className="text-sm mt-2">{msg.contenido}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
